import cn from 'classnames';
import { Grid2 } from "@mui/material";

import classes from './index.module.scss';

const TableCell = ({
  clearBorderTop,
  clearBorderRight,
  clearBorderBottom,
  clearBorderLeft,
  clearPadding,
  clearFullHeight,
  center,
  caption,
  bold,
  fullWidth,
  fullHeight,
  noWrap,
  children,
  className,
  html,
  ...props
}) => {
  return (
    <Grid2
      container={!!center}
      className={cn(classes.cell, className, {
        [ classes.caption ]: !!caption,
        [ classes.center ]: !!center,
        [ classes.bold ]: !!bold,
        [ classes.noBorderTop ]: !!clearBorderTop,
        [ classes.noBorderRight ]: !!clearBorderRight,
        [ classes.noBorderBottom ]: !!clearBorderBottom,
        [ classes.noBorderLeft ]: !!clearBorderLeft,
        [ classes.noPadding ]: !!clearPadding,
        [ classes.clearFullHeight ]: !!clearFullHeight,
        [ classes.fullHeight ]: !!fullHeight,
        [ classes.noWrap ]: !!noWrap,
      })}
      {...props}
    >
      {
        html ? (
          <Grid2
            className={fullWidth ? classes.fullWidth : ''}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        ) : (
          <Grid2
            className={fullWidth ? classes.fullWidth : ''}
          >
            {
              children
            }
          </Grid2>
        )
      }
    </Grid2>
  )
}

export default TableCell;